export const Drawer = {
  sizes: {
    '2xl': { dialog: { maxW: '6xl' } },
    '3xl': { dialog: { maxW: '8xl' } },
  },
}
